module.exports = __webpack_public_path__ + "08e6d0ccf51453294633340d69483aa2.svg";